import { render, staticRenderFns } from "./create-favorites.vue?vue&type=template&id=9d69f452&"
import script from "./create-favorites.vue?vue&type=script&lang=js&"
export * from "./create-favorites.vue?vue&type=script&lang=js&"
import style0 from "./create-favorites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports